import React from "react";
import { Link } from "react-router-dom";
import IncrementCounter from "../../common/IncrementCounter";

function Slider2({ setTab }) {
  return (
    <div className="image-container" id="slider2">
      <div className="image-half">
        <img
          src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/bg-image/surgery.jpg"
          alt="surgery"
        />
      </div>
      <div className="overlay"></div>
      <div className="content">
        <span className="heading1">Welcome To</span>
        <br />
        <span className="heading2">
          Prasad <span style={{ color: "#12b48b" }}>Eye</span> Hospital
        </span>
        <br />
        <p className="para">
          Prasad Eye Hospital, a leading eye care center in Eastern India, has
          successfully
          <br />
          over{" "}
          {
            <IncrementCounter
              intialCount={60000}
              startYear={2025}
              incrementPerYear={18000}
            />
          }{" "}
          treated patients by December {new Date().getFullYear() - 1} and is a
          pioneer in
          <br />
          Phacoemulsification and lens implantation technology.
        </p>
        <Link
          to="/appointment"
          className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor margin_top15"
          onClick={() => setTab("appointment")}
        >
          Book Appointment
        </Link>
      </div>
    </div>
  );
}

export default Slider2;
